// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2GMqU","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3X0oM","obliqueLine":"membershipbadge_obliqueLine__1LM9_"};